import { render, staticRenderFns } from "./PatientsList.vue?vue&type=template&id=cab34902&"
import script from "./PatientsList.vue?vue&type=script&lang=js&"
export * from "./PatientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports